"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ApiError;
(function (ApiError) {
    ApiError["transaction_broadcast_failed"] = "transaction_broadcast_failed";
    ApiError["api_connection_failed"] = "api_connection_failed";
})(ApiError || (ApiError = {}));
var ApiModule = /** @class */ (function () {
    function ApiModule(apis) {
        this.dbApi = apis.dbApi || null;
        this.chainApi = apis.chainApi || null;
        this.historyApi = apis.historyApi || null;
        this.messagingApi = apis.messagingApi || null;
        this.apiConnector = apis.apiConnector || null;
    }
    ApiModule.prototype.handleError = function (message, err) {
        if (process.env.ENVIRONMENT === 'DEV') {
            console.log("debug => " + message + " | " + err);
        }
        var error = new Error(message);
        error.stack = err;
        return error;
    };
    ApiModule.prototype.finalizeAndBroadcast = function (transaction, privateKey, broadcast) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            transaction.setTransactionFees()
                .then(function (res) {
                if (broadcast) {
                    transaction.broadcast(privateKey)
                        .then(function (res) { return resolve(transaction.operations[0]); })
                        .catch(function (err) {
                        reject(_this.handleError(ApiError.transaction_broadcast_failed, err));
                    });
                }
                else {
                    resolve(transaction.operations[0]);
                }
            })
                .catch(function (err) {
                reject(_this.handleError(ApiError.api_connection_failed, err));
            });
        });
    };
    return ApiModule;
}());
exports.ApiModule = ApiModule;
//# sourceMappingURL=ApiModule.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/modules/ApiModule.js
// module id = 12
// module chunks = 0